<template>
  <b-card
    :header="textVariant.lang | getLangNameEn"
    bg-variant="light"
  >
    <div class="form-group">
      <label :for="titleInputId">Title</label>
      <input
        v-model="title"
        :id="titleInputId"
        class="form-control"
        required
      >
    </div>

    <div class="form-group">
      <label :for="messageTextareaId">Message</label>
      <textarea
        v-model="message"
        :id="messageTextareaId"
        class="form-control"
        rows="3"
        required
      />
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'PushTextVariantInput',

  props: {
    textVariant: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      lang:    this.textVariant.lang,
      title:   this.textVariant.title,
      message: this.textVariant.message,
    };
  },

  computed: {
    titleInputId() {
      return 'title-' + this.lang;
    },

    messageTextareaId() {
      return 'message-' + this.lang;
    },
  },

  methods: {
    getLang() {
      return this.lang;
    },

    getTitle() {
      return this.title;
    },

    getMessage() {
      return this.message;
    },
  },
};
</script>

<style scoped>
  .form-group:last-child {
    margin-bottom: 0px;
  }
</style>
